window.addEventListener(`DOMContentLoaded`, () => {
  function replaceTextInNode(node, searchText, replacementText) {
    if (node.nodeType === Node.TEXT_NODE) {
      if (node.textContent.includes(searchText)) {
        node.textContent = node.textContent.replace(searchText, replacementText);
      }
    } else {
      for (let i = 0; i < node.childNodes.length; i++) {
        replaceTextInNode(node.childNodes[i], searchText, replacementText);
      }
    }
  }

  let currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth() + 1; // getMonth возвращает месяцы начиная с 0, поэтому добавляем 1
  const day = currentDate.getDate();
  const nextYearPeriod = year + 3;
  // const bndaString = '2025 / 2028 / 2031'
  const bndaString2 = '1 декабря 2025'
  // const bndbString = '2026 / 2029 / 2032'
  const bndbString2 = '1 декабря 2026'
  // const bndcString = '2027 / 2030 / 2033'
  const bndcString2 = '1 декабря 2027'
  let bndaYear = (year - 2025) % 3
  let bndbYear = (year - 2026) % 3
  let bndcYear = (year - 2027) % 3

  function updateYears(yearString, currentYear) {
    // Преобразуем строку в массив чисел
    let yearArray = yearString.split(" / ").map(Number);
    // Начальный год
    let baseYear = yearArray[0];
    // Определяем количество сдвигов
    let shiftCount = Math.ceil((currentYear - baseYear) / 3);
    // Обновляем значения в массиве, сдвигая на +3 года за каждую итерацию
    let updatedYears = yearArray.map(year => year + shiftCount * 3);
    // Преобразуем массив обратно в строку
    return updatedYears.join(" / ");
  }

  function updateDecemberYear(dateString, currentYear) {
    // Извлекаем год из строки
    let baseYear = parseInt(dateString.match(/\d{4}/)[0], 10);
    // Определяем количество сдвигов
    let shiftCount = Math.ceil((currentYear - baseYear) / 3);
    // Вычисляем новый год
    let updatedYear = baseYear + shiftCount * 3;
    // Обновляем строку с новым годом
    return `1 декабря ${updatedYear}`;
  }
// Пример использования
//   replaceTextInNode(document.body, bndaString, updateYears(bndaString, year));
//   replaceTextInNode(document.body, bndbString, updateYears(bndbString, year));
//   replaceTextInNode(document.body, bndcString, updateYears(bndcString, year));

  replaceTextInNode(document.body, bndaString2, updateDecemberYear(bndaString2, year));
  replaceTextInNode(document.body, bndbString2, updateDecemberYear(bndbString2, year));
  replaceTextInNode(document.body, bndcString2, updateDecemberYear(bndcString2, year));

  if (bndaYear === 0 && month > 11 && day > 1) {
    replaceTextInNode(document.body, '1 декабря 2025 ', '1 декабря ' + nextYearPeriod + ' ');
  }
  if (bndbYear === 0 && month > 11 && day > 1) {
    replaceTextInNode(document.body, '1 декабря 2026 ', '1 декабря ' + nextYearPeriod + ' ');
  }
  if (bndcYear === 0 && month > 11 && day > 1) {
    replaceTextInNode(document.body, '1 декабря 2027 ', '1 декабря ' + nextYearPeriod + ' ');
  }

})
